import { UserType } from '@linktivity/triplabo-taxi';

// lobby environment
export const isHardwareEnvironment = () => {
  // 由于GA会将自定义useragent头定义为非法，导致埋点失败；现改为通过 Android 接口判断
  return Boolean(window.Android?.isHotelLobby?.());
};

// wechat environment
export const isWeChatEnvironment = () => {
  const ua = navigator.userAgent.toLowerCase();
  const isWeChat = ua.includes('miniprogram');
  return isWeChat;
};

// harmony app environment
// export const isHarmonyAppEnvironment = () => {
//   const ua = navigator.userAgent.toLowerCase();
//   return ua.includes('triplaboharmonyapp');
// };

// harmony ascf environment
export const isHarmonyEnvironment = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes('ascf');
};

// web environment
export const isWebEnvironment = () => {
  const ua = navigator.userAgent.toLowerCase();
  const isWeChat = ua.includes('miniprogram');
  const isAndroid = isHardwareEnvironment();
  const isHarmony = isHarmonyEnvironment();

  return !isWeChat && !isAndroid && !isHarmony;
};

// 获取当前设备类型
export const getCurrentDevice = (): UserType => {
  try {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return UserType.Unknown;
    }
    const isWeChat = isWeChatEnvironment();
    if (isWeChat) {
      return UserType.Wechat;
    }
    const isHardware = isHardwareEnvironment();
    if (isHardware) {
      return UserType.Hardware;
    }
    const isWeb = isWebEnvironment();
    if (isWeb) {
      return UserType.Web;
    }
    return UserType.Unknown;
  } catch (error) {
    console.error('Device detection failed:', error);
    return UserType.Unknown;
  }
};

export const isHardware = isHardwareEnvironment();
export const isWeb = isWebEnvironment();
export const isWechat = isWeChatEnvironment();
export const isHarmony = isHarmonyEnvironment();
